import React from 'react';
import { MaintenanceContainer } from './screen/container/maintenanceContainer';

export const MaintenanceScreen = (): React.ReactElement => {
    return (
        <MaintenanceContainer />
    );
};
